import * as React from 'react';
import {FC} from 'react';
import {Tabs} from '@flexe/ui-components';
import {ManifestLpns} from './ManifestLpns';
import {ManifestLpn} from './ManifestInterfaces';

interface Props {
  manifestLpns: ManifestLpn[];
  manifestLpnsCount: number;
  pageSize: number;
  currentManifestLpnsPage: number;
  authenticityToken: string;
  allowEditing: boolean;
  handlePagination(page);
  setRefreshLpns(value);
}

export const ManifestContents: FC<Props> = (props) => {
  const [selectedTab, setSelectedTab] = React.useState(LPNS_TAB);

  const header = () => {
    return (
      <React.Fragment>
        <h2>Contents</h2>
      </React.Fragment>
    );
  };

  const onTabSelection = (key: string) => {
    if (key === selectedTab) {
      return;
    }
    setSelectedTab(key);
  };

  return (
    <React.Fragment>
      <div id="manifest-contents">
        <div className="container-fluid">
          <div className="contents-container">
            <header>{header()}</header>
            <Tabs
              tabs={[
                {
                  active: selectedTab === LPNS_TAB,
                  key: LPNS_TAB,
                  title: `LPNs (${props.manifestLpnsCount})`
                }
              ]}
              tabEvent={(tabKey) => onTabSelection(tabKey)}
            />

            {selectedTab === LPNS_TAB && (
              <div>
                <ManifestLpns
                  manifestLpns={props.manifestLpns}
                  manifestLpnsCount={props.manifestLpnsCount}
                  pageSize={props.pageSize}
                  currentManifestLpnsPage={props.currentManifestLpnsPage}
                  handlePagination={props.handlePagination}
                  setRefreshLpns={(value) => props.setRefreshLpns(value)}
                  authenticityToken={props.authenticityToken}
                  allowEditing={props.allowEditing}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const LPNS_TAB = 'lpns';
